import AbstractComponent from './AbstractComponent';

class Player extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.handleVideoEvent = this.handleVideoEvent.bind(this);
    this.handleClickPlay = this.handleClickPlay.bind(this);
    this.handleClickVideo = this.handleClickVideo.bind(this);
  }

  getUI() {
    const ui = super.getUI();
    ui.$play = ui.$element.querySelector('.player__play');
    ui.$video = ui.$element.querySelector('video');
    return ui;
  }

  events(listen) {
    const eventListener = listen ? 'addEventListener' : 'removeEventListener';
    this.ui.$play[eventListener]('click', this.handleClickPlay);
    this.ui.$video[eventListener]('click', this.handleClickVideo);
    this.ui.$video[eventListener]('play', this.handleVideoEvent);
    this.ui.$video[eventListener]('pause', this.handleVideoEvent);
    this.ui.$video[eventListener]('end', this.handleVideoEvent);
  }

  handleVideoEvent(event) {
    switch (event.type) {
      case 'play':
        this.ui.$element.classList.add('is-playing');
        break;
      case 'pause':
      case 'end':
        this.ui.$element.classList.remove('is-playing');
        break;
    }
  }

  handleClickPlay() {
    this.ui.$video.play();
  }

  handleClickVideo() {
    this.ui.$video.pause();
  }
}

export default Player;
